export default {"src":"/_next/static/media/IOS.ab91f62a.svg","height":48,"width":48};